/**
 * @class
 * @classdesc Model for Zone on DB
 * * */
export default class Zone {
  /**
   * Constructor - sets a model for zone Data according to DB
   * @param {Number} id
   * @param {String} name
   * @param {String} code
   */

  #FleetObject = {}

  constructor(id, name, code) {
    this.#FleetObject.ID = id || 0
    this.#FleetObject.Name = name || ''
    this.#FleetObject.Code = code || ''
  }

  /**
   * Get Fleet Object
   * @return {Object} Fleet Javascript object
   */
  getObject() {
    return this.#FleetObject
  }
}
